<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<!-- <h2 class="text-center">{{ title }}</h2> -->
					<h2 class="text-center">Фотографії оголошення</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							<!-- № {{ id }} -->
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<div class="mx-8 my-6">
					<v-row>
						<v-col v-for="(file, index) in files" :key="index"
							class="d-flex child-flex"
							cols="4"
						>
							<img :src="getFileUrl(file)"></img>
						</v-col>
					</v-row>
				</div>
				<!-- <v-row v-for="(fotos, ekey) in data" :key="ekey"  >
					<v-col v-for="(foto, fkey) in fotos" :key="fkey"
						class="d-flex child-flex"
						cols="4"
					>
						<img :src="foto.formats[1]"></img>
					</v-col>
				</v-row> -->
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	data: () => ({
		options: {
			//margin: [10,10,10,10],
			margin: [10,0,10,0],
			filename: `Фотографії оголошення.pdf`,
			image: { type: 'jpeg', quality: 0.98 },
			enableLinks: false,
			html2canvas: { scale: 1, useCORS: true },
			jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
			pagebreak: { avoid: ['div'] },
		}
	}),

	computed: {
		files() {
			return this.item?.files ? this.item.files : []
		},
	},

	methods: {
		getFileUrl(file) {
			return URL.createObjectURL(file);
		},
	},
}

</script>